import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react'
import popupStyle from './../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import GlobalButton from '../../../utility/globalButton/button'
import WhatsappTemplateIntegration from './whatsappTemplateIntegration'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext'
import GlobalPopUp from '../../../utility/globalPopUp'
import CreateVariablePopup from '../../../dashboard/flowBuilder/leftSectionComponents/components/dataCollections/createVariablePopup'
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup'
import { UserContext, UserContextPayload } from '../../../../context/userContext'
import agent from '../../../../services/api'
import { useSearchParams } from 'react-router-dom'
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext'
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore'
import { isCurrentViewVersionPublished } from '../../../dashboard/flowBuilder/utilityFunctions'
import { useGenericStore } from '../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import { chatbotIntegratedChannelDeploymentObj, metaIntegrationWhatsappPhoneNumberData } from '../../../../models/axiosModel'

const TemplateDetailsComponent = (props: any) => {
    const { actionData, stepAction, setFlagTemplatePopup } = props;
    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');
    const [searchParams] = useSearchParams()
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const [tempActionData, setTempActionData] = useState(JSON.parse(JSON.stringify(actionData)))
    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const flagDataCollectionPopup = useFlowBuilderStore((state) => state.flagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const flagDeleteFieldData = useFlowBuilderStore((state) => state.flagDeleteFieldData)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const { onChangeCurrentActiveNodeConfig, inValidHeaderId, inValidButtonId, inValidVariableId, tempNodesTemplate, nodes, currentActiveNodeConfig, onBlurOfFallBackOfBtnVar, deleteEdgesRelatedToStepAction, edges } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow, updateChatbotDeploymentDetails } = useContext(WorkflowContext) as WorkflowContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const whatsAppChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj;
    
    const [selectedWBA, setSelectedWBA] = useState<chatbotIntegratedChannelDeploymentObj>(whatsAppChannel);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<metaIntegrationWhatsappPhoneNumberData>(whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0] || null);
    const [waTemplateFetchedOnChange, setWaTemplateFetchedOnChange] = useState(false);

    async function saveTemplateDetails() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let response = {
            status: true
        }
        if (selectedWBA?.meta_integration_whatsapp_id !== whatsAppChannel?.meta_integration_whatsapp_id || selectedPhoneNumber?.integrated_channel_id !== whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0].integrated_channel_id) {

            let payload: any = {
                chatbot_id: currentActiveStaticWorkflow?.chatbot_id,
                chatbot_name: currentActiveStaticWorkflow?.chatbot_name,
                chatbot_channel_configuration: {
                    integrated_channel_id: selectedPhoneNumber?.integrated_channel_id ?? null,
                    meta_integration_whatsapp_id: selectedWBA?.meta_integration_whatsapp_id ?? null,
                    channel_content_type_id: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment.deployment_channel_content_type_data.channel_content_type_id
                },
                chatbot_step_deployment_trigger_data: currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase())?.chatbot_step_deployment_trigger_data, 
                chatbot_thread_timeout_config: currentActiveStaticWorkflow?.chatbot_thread_timeout_config,
            }
            response = await updateChatbotDeploymentDetails(payload) 
            if(response.status){ 
                setCurrentActiveStaticWorkflow((prev: any) => ({
                    ...prev,  
                    // @ts-ignore
                    chatbot_integrated_channel_deployment: response.data?.[0]?.chatbot_integrated_channel_deployment,
                }))
            }
        }
        if (response.status) {
            const updated_node = nodes?.map((node: any) => { 
                if (node?.id !== currentActiveNodeConfig?.nodeId) return node;

                let updatedData = node?.data;
                if(tempActionData.whatsapp_template.whatsapp_template_id !== actionData.whatsapp_template.whatsapp_template_id){ // In the case of Template change
                    updatedData = updatedData?.filter((data: any) => {
                        const saveVariableAction =
                            data?.action_type?.action_type_name === "save_variable" &&
                            ((Array.isArray(data?.action_data) &&
                            (data?.action_data?.[0]?.action_data?.value_type === "user_flow_message_payload" || data?.action_data?.[0]?.action_data?.value_type === "user_message_payload")) ||
                            (data?.action_data?.value_type === "user_message_text" && !data?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id));
                        return !saveVariableAction;
                    });
                } 
                return {
                    ...node,
                    data: updatedData,
                };
            }) 
            onBlurOfFallBackOfBtnVar(updated_node, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                {
                    ...actionData,
                },
                {
                    updateType: "editExistingStepAction"
                }
            );

            if (tempActionData.whatsapp_template.whatsapp_template_id !== actionData.whatsapp_template.whatsapp_template_id) { //template has been changed
                deleteEdgesRelatedToStepAction(edges, currentActiveNodeConfig.nodeId)
            } 

            // Need to delete all payload keys saved in save_variable. 
            const saveVariableAction = nodes?.find((node: any) => node?.id == currentActiveNodeConfig.nodeId)?.data?.find((data: any) => data?.action_type?.action_type_name == "save_variable" && Array.isArray(data?.action_data) && (data?.action_data?.[0]?.action_data?.value_type == "user_flow_message_payload" || data?.action_data?.[0]?.action_data?.value_type == "user_message_payload")); 
            if(saveVariableAction && tempActionData.whatsapp_template.whatsapp_template_id !== actionData.whatsapp_template.whatsapp_template_id){
                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, saveVariableAction.chatbot_step_action_id, 
                    { 
                        ...saveVariableAction?.action_data, 
                        type: "take_value_from_text" 
                    },
                    {
                        updateType: "editExistingStepAction"
                    }
                )
            }

            setFlagTemplatePopup(false)
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleDeleteFieldData = async () => {
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
        const res = await agent.deleteChatbotCustomVariable.delete(existingCustomVariablePayload.chatbot_custom_variable_config_id)
        if (res.status) {
            showSuccess("Field Deleted Successfully")
            await GetCustomVariableListApi(searchParams.get("workflow_id") || "")
        }
        else {
            handleError(res);
        }
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });
    }

    const isSaveTemplateDisabled = () => {
        if (!actionData?.whatsapp_template?.whatsapp_template_id || !actionData?.whatsapp_template?.whatsapp_template_name) {
            return true
        }
        else if (actionData?.action_send_dm_wa_template_variable_data?.some((data: any) => !data.chatbot_custom_variable_configuration && (data?.fallback_value?.trim() == "" || !data?.fallback_value) && !data.metadata_type)) {
            return true
        } 
        else if (actionData?.action_send_dm_wa_carousel_template_variable_data?.some((data: any) => !data.chatbot_custom_variable_configuration && (data?.fallback_value?.trim() == "" || !data?.fallback_value) && !data.metadata_type)){
            return true;
        } 
        else if (inValidHeaderId?.length > 0 || inValidButtonId?.length > 0 || inValidVariableId?.length > 0) {
            return true
        }  
        else if(actionData?.action_send_order_details_template_variable_data?.some((data: any) => !data.chatbot_custom_variable_configuration && (data?.fallback_value?.trim() == "" || !data?.fallback_value) && !data.metadata_type)){
            return true;
        }
        // else if (actionData?.action_send_dm_wa_any_template_flow_variable?.length > 0 && actionData?.action_send_dm_wa_any_template_flow_variable?.[0]?.action_send_dm_wa_any_template_flow_input_variable?.every((variable: any) => !(variable?.chatbot_custom_variable_configuration) && !(variable?.metadata_type?.metadata_type_id) && !(variable?.fallback_value))) {
        //     return true;
        // }
        return false;
    }

    return (
        <Grid container direction={"column"} gap={"20px"} padding={"30px"} sx={{ zIndex: "1", height: "100%" }} flexWrap={"nowrap"}>
            <Grid item sx={{ width: "100%" }} textAlign={"center"}>
                <span className={popupStyle.popupTitleStyle}>{currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] ? `Select Template` : `Configure WhatsApp Business Account`}</span>
            </Grid>
            <Grid item>
                <Divider style={{ opacity: "0.2", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
            </Grid>
            <Grid item sx={{ width: "100%", height: "85%", overflow: "auto" }}>
                <Grid container direction={"column"} gap={"15px"} sx={{ height: "100%" }} flexWrap={"nowrap"}>
                    <WhatsappTemplateIntegration waTemplateFetchedOnChange={waTemplateFetchedOnChange} setWaTemplateFetchedOnChange={setWaTemplateFetchedOnChange} selectedWBA={selectedWBA} setSelectedWBA={setSelectedWBA} selectedPhoneNumber={selectedPhoneNumber} setSelectedPhoneNumber={setSelectedPhoneNumber} actionData={actionData} stepAction={stepAction} />
                </Grid>
            </Grid>
            {
                <Grid item sx={{ width: "100%" }} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    if (waTemplateFetchedOnChange) {
                                        setWaTemplateFetchedOnChange(false)
                                    }
                                    onChangeCurrentActiveNodeConfig(tempNodesTemplate, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                        {
                                            ...tempActionData,
                                            flag_cancel_update: true
                                        },
                                        {
                                            updateType: "editExistingStepAction"
                                        }
                                    ); 
                                    setFlagTemplatePopup(false) // Close the Popup
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                onClick={() => {
                                    saveTemplateDetails()
                                }}
                                disabled={isSaveTemplateDisabled() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            />
                        </Grid>
                    </Grid>
                </Grid>}

            {flagDataCollectionPopup &&
                <GlobalPopUp
                    open={flagDataCollectionPopup}
                    onClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                    // title={}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                    handleClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                >
                    <CreateVariablePopup />
                </GlobalPopUp>
            }

            {flagDeleteFieldData &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to delete ${existingCustomVariablePayload.chatbot_custom_variable_name} field`}
                    open={flagDeleteFieldData}
                    onClose={() => { setFlagDeleteData(false) }}
                    onDelete={() => {
                        handleDeleteFieldData()
                        setFlagDeleteData(false)
                    }}
                />
            }

        </Grid>
    )
}

export default TemplateDetailsComponent
